import {
    GET_USER_SETTINGS
    , UPDATE_USER_SETTINGS
    , SET_USER_SETTING_DATA
} from '../actions/entityManagementSettingActions';

const initialState = {
    userSettings: {}
    ,userSettingsIsFetching: false
    ,userSettingsIsUpdating: false
};

export function userSettings(state = initialState, action) {
    switch (action.type) {

        case GET_USER_SETTINGS.pending:
        {
            return {
                ...state,
                userSettingsIsFetching: true
            };
        }
        case GET_USER_SETTINGS.fulfilled:
        {
            return {
                ...state,
                lastError: undefined,
                userSettingsIsFetching: false,
                userSettings: action.payload
            };
        }

        case GET_USER_SETTINGS.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                userSettingsIsFetching: false,
                userSettings: undefined
            };
        }

        case UPDATE_USER_SETTINGS.pending:
        {
            return {
                ...state,
                userSettingsIsUpdating: true
            };
        }
        case UPDATE_USER_SETTINGS.fulfilled:
        {
            return {
                ...state,
                lastError: undefined,
                userSettingsIsUpdating: false,
                userSettings: action.payload
            };
        }

        case UPDATE_USER_SETTINGS.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                userSettingsIsUpdating: false,
                userSettings: undefined
            };
        }
        case SET_USER_SETTING_DATA: {
            return{
                ...state,
                userSettings: action.payload,
                lastError: undefined,
                userSettingsIsUpdating: false
            };
        }
        default: {
            return state;
        }
    }
} 
